import { PropertyBrowserTreeNode } from "api-client";
import clsx from "clsx";
import DropdownBrowser from "components/DropdownBrowser";
import React from "react";
import { useTranslation } from "react-i18next";
import PropertyInput from "./PropertyInput";
import { ConditionProps } from "./ConditionRow";
import { rulesSetStore } from "../RulesSetStore";
import { observer } from "mobx-react-lite";

interface PropertyFieldProps {
  items?: PropertyBrowserTreeNode[];
  onRemoveProperty: () => void;
  row: ConditionProps;
  onSelectProperty: (value: PropertyBrowserTreeNode) => void;
}

function PropertyField(props: PropertyFieldProps) {
  const { t, i18n } = useTranslation();
  const isEng = i18n.language === "en";
  const [propertySearchMode, setPropertySearchMode] = React.useState(false);
  const [propertySearchTerm, setPropertySearchTerm] = React.useState("");
  const propertyName = isEng
    ? props.row.property?.name
    : props.row.property?.name_de;

  React.useEffect(() => {
    setPropertySearchTerm("");
  }, [rulesSetStore.currentRule?.id]);

  const handleOpenPropertyMenu = (state: boolean) => {
    setPropertySearchMode(state);
    if (!state) {
      setPropertySearchTerm("");
    }
  };

  const handleRemoveProperty = () => {
    setPropertySearchTerm("");
    props.onRemoveProperty();
  };

  return (
    <div className="relative w-full">
      <DropdownBrowser<PropertyBrowserTreeNode>
        displayKey={isEng ? "name" : "name_de"}
        detailKey={isEng ? "classification" : "classification_de"}
        name="filter_by"
        items={props.items}
        placeholder={t("rulesEditor.selectProperty")}
        optionsClassName="!max-w-fit min-w-[246px]"
        containerClassName="relative"
        singleSelect
        fixedPos
        labelWithSearch
        searchTerm={propertySearchTerm}
        isOpen={handleOpenPropertyMenu}
        selectInputClassName="w-full"
        buttonClassName={clsx(
          "w-full",
          props.row.property ? "pointer-events-none" : ""
        )}
        checkedItems={props.row.property ? [props.row.property] : []}
        titleOrIcon={
          <PropertyInput
            value={propertySearchTerm || propertyName}
            onChangeSearch={setPropertySearchTerm}
            onRemoveClicked={handleRemoveProperty}
            isObject={!!propertyName}
            placeholder={t("rulesEditor.selectProperty")}
            searchMode={propertySearchMode}
          />
        }
        handleSelect={(value) => props.onSelectProperty(value[0])}
      />
    </div>
  );
}

export default observer(PropertyField);
